export default {
  name: 'Article list section - 9',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Item button 1","button-link":"#","button-style":"default","button-background-color":"var(--accent-color)","button-text-color":"var(--text-dark-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Item button 2","button-link":"#","button-style":"default","button-background-color":"var(--accent-color)","button-text-color":"var(--text-dark-color)"},{"article-title":"Article 3","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"Item button 3","button-link":"#","button-style":"default","button-background-color":"var(--accent-color)","button-text-color":"var(--text-dark-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/federica-galli-pF1ug8ysTtY-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--accent-color)',
    'title-font-weight': 'lighter',
    'title-tag': 'h2',
    'introtext-color': 'inherit',
    'article-title-color': 'var(--text-light-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h5',
    'article-introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'lg',
    'content-horizontal-alignment': 'center',
    'article-columns': '3',
    'content-box': '1',
    'content-box-wrap': 'content',
    'content-box-color': 'var(--primary-color)',
    'content-box-padding': '30px',
    'content-box-opacity': '0.8',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
